import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class TimestampInput extends TextInput {}

registerCustomElement('imt-input-timestamp', TimestampInput);
